var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg100PctCustom = function Svg100PctCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 225,
    fill: "none",
    viewBox: "0 0 524 524"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#100-pct-custom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E97FB0",
    d: "M513 237c14 14 14 36 0 50L287 513a36 36 0 0 1-50 0L11 287a36 36 0 0 1 0-50L237 11c14-14 36-14 50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M262 56 56 262l206 206 206-206zm0 384 178-178L262 85 85 262z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97FB0",
    fillRule: "evenodd",
    d: "M72 200h380c26 25 39 46 39 62s-13 43-39 79H72c-23-36-35-63-35-79s12-37 35-62",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156 281c-10 18-27 25-36 25s-10-7-10-12l1-11h1c14 0 25-4 32-10 12-9 18-21 18-31 0-11-6-21-19-21-20 0-37 24-45 46-10-3-10-12-10-14 0-10 7-13 7-13l-8-12c-8 4-14 14-14 25 0 13 8 23 21 28l-1 13c0 14 7 23 23 23 19 0 35-13 46-32-1-2-3-4-6-4m-16-43c3 0 4 2 4 5 0 4-2 12-9 18-5 4-11 7-19 8 6-16 16-31 24-31m78 43c-8 13-14 21-19 21-2 0-4-2 1-14l13-33h-17l-12 29c-6 10-10 16-14 16-3 0-4-1 0-12l14-33h-18l-12 30c-8 20-1 27 9 27q10.5 0 18-9c1 6 6 9 12 9 12 0 23-12 31-27-1-2-4-4-6-4m6 4 8-15v17c0 11-2 14-5 14l-4-2-9 6s5 7 18 7c18 0 29-13 37-27-1-2-4-4-6-4-5 8-10 14-15 19v-6c0-7-2-24 1-39l-15-4-16 30c1 2 4 4 6 4m73-4c-8 13-15 21-20 21-3 0-5-2 0-14l13-33h9l3-9h-8l5-12h-17l-6 12h-8l-4 9h9l-12 30c-8 19-1 27 9 27 14 0 25-13 33-27-1-2-4-4-6-4m62 0c-4 8-10 12-15 12 3-6 5-13 5-19 0-13-7-20-20-20-23 0-34 23-34 38 0 12 7 20 21 20 9 0 17-4 22-10 11 1 21-7 27-17-1-2-4-4-6-4m-43 20c-3 0-4-2-4-6 0-8 8-30 16-30 3 0 5 1 5 5l-3 11c-5 0-9 4-9 9l2 6c-2 3-5 5-7 5m137-20c-8 13-15 21-19 21-2 0-4-2 1-14l5-13 3-12c0-6-3-9-10-9-10 0-18 6-21 9 0-6-3-9-10-9-9 0-17 6-18 7l3-6h-18l-22 56h17l15-36c4-5 9-8 12-8 1 0 3 1 3 3l-4 11-13 30h18l14-36c5-5 10-8 12-8s3 1 3 3l-4 11-1 4c-8 19-3 27 8 27 13 0 23-12 32-27-1-2-4-4-6-4m-288-52h103v3H165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m263 389-19 14 7-22-18-14h23l7-22 7 22h23l-18 14 7 22z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M310 229h144v3H310zm-206 94h327v3H104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M288 169a7 7 0 1 0 14 0c0-4-3-7-7-7s-7 3-7 7m-62 13c0 11 5 18 14 18s13-7 13-18-5-19-13-19-14 7-14 19m-15-7v24l1 1h6l1-1v-34l-1-1h-5l-8 6v4l1 1zm28 18c3 0 5-4 5-11s-2-11-5-11-5 4-5 11 2 11 5 11m18-11c0 11 5 18 14 18s13-7 13-18-5-19-13-19-14 7-14 19m14 11c3 0 5-4 5-11s-2-11-5-11-5 4-5 11 2 11 5 11m20 6 18-35 1-1h4l1 1-18 35-1 1h-4zm6-30-2 2-2-2 2-2zm8 24a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7 2-2-2 2-2 2 2z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "100-pct-custom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h524v524H0z"
  })))));
};
export default Svg100PctCustom;